import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from "@mui/material";

import React from "react";
import { makeStyles } from '@mui/styles'
import DeleteButton from "./DeleteButton";

const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
    },
    paper: {
      width: '80%',
      maxHeight: 435,
    },
    actionsPanel: {
        // background: grey[100],
        // display: 'block',
    }
  }));
  
function ConfirmationDialog(props) {
    // Our own props stay out of `other`: it is spread onto the Dialog root, where
    // React warned about every one of them as an unknown DOM attribute (and
    // `title` became a native hover tooltip).
    const {
        onCancel, onConfirm, value: valueProp, open, children,
        title, okButtonText, cancelButtonText, formInput, formInputRef, validate,
        okButtonIcon, standardActions, destructive,
        ...other
    } = props;
    const classes = useStyles();
    
    const [errors, setErrors] = React.useState(null);

    const handleCancel = () => {
        props.onCancel && props.onCancel();
    };
  
    const handleOk = () => {
        props.onConfirm && props.onConfirm();
    };

    // CP-5545: a delete confirmation's OK is the shared DELETE (outlined red + trash, never filled). It is
    // picked from the label ("Delete…"), so the many callers with per-action text maps need no change;
    // `destructive` overrides that either way (e.g. a "Remove" that deletes).
    const isDelete = destructive ?? /^\s*delete\b/i.test(okButtonText || '');
    const okButton = isDelete ? (
        <DeleteButton onClick={handleOk} disabled={!!errors}>{okButtonText || "Delete"}</DeleteButton>
    ) : (
        <Button onClick={handleOk} color="primary" disabled={!!errors} variant="contained" startIcon={okButtonIcon}>{okButtonText || "Ok"}</Button>
    );

    const handleChange = (event) => {
        props.formInputRef.current = event.target.value
        const error_msg = props.validate?.(event.target.value)
        if (error_msg){
            setErrors(error_msg)
        }
        else{
            setErrors(null)
        }
    };
  
    return (
        <Dialog
            // disableBackdropClick
            disableEscapeKeyDown
            maxWidth="xs"
            aria-labelledby="confirmation-dialog-title"
            open={open}
            {...other}
        >
            <DialogTitle id="confirmation-dialog-title">{props.title || "Please confirm"}</DialogTitle>
            <DialogContent>
                <Box mb={4}>
                    {children}
                </Box>
                {props.formInput && <TextField
                    style={{width: "100%"}}
                    id="confirmation_dialog_form_input"
                    defaultValue={props.formInput}
                    onChange={handleChange}
                    error={!!errors}
                    helperText={errors}

                />}
            </DialogContent>

            <DialogActions className={classes.actionsPanel}>
                {/* <Box m={1}> */}
                {standardActions ? (
                    // CP-8423 opt-in: [CANCEL] [OK] bottom-right, CANCEL outlined primary.
                    <Box display="flex" justifyContent="flex-end" alignItems="center" gap={1} flexWrap="wrap" width="100%" p={1}>
                        <Button autoFocus variant="outlined" color="primary" onClick={handleCancel}>{props.cancelButtonText || "Cancel"}</Button>
                        {okButton}
                    </Box>
                ) : (
                <Grid container p={1} spacing={2} >
                    <Grid item >{okButton}</Grid>
                    <Grid item  ><Button autoFocus variant="outlined" onClick={handleCancel}>{props.cancelButtonText || "Cancel"}</Button></Grid>
                </Grid>
                )}
            </DialogActions>
        </Dialog>
    );
}
  
export default ConfirmationDialog;
